import React from 'react';
import { useIntl } from 'react-intl';
import type { XPostsUsage } from 'fym-shared/src/music24/xPosts';
import { TypedMemo } from '../../../common/types';
import type { CalendarPost } from '../types';
import { xMessages } from '../xMessages';
import { isXDraftAtMonthLimit } from '../xPostsLimit';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the panel; each part uses its own slice of it */
import styles from './DayPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostXLimitNoteProps {
  post: Pick<CalendarPost, 'platform' | 'status' | 'scheduledAt'>;
  /** The X posts of this month of the X channel, or null. */
  xPosts: XPostsUsage | null;
}

/**
 * The reason of an X draft in the Calendar day: "X limit reached this month" (design x-connector
 * d3). The artist posts it by hand or gives it a time in a later month.
 */
const PostXLimitNoteComponent: React.FC<PostXLimitNoteProps> = ({ post, xPosts }) => {
  const intl = useIntl();
  if (!isXDraftAtMonthLimit(post, xPosts)) {
    return null;
  }
  return (
    <p className={styles.xLimitNote} role="note" data-testid="post-x-limit-note">
      {intl.formatMessage(xMessages.calendarMonthLimit)}
    </p>
  );
};

export const PostXLimitNote = TypedMemo(PostXLimitNoteComponent);
